export function formatMoney(value, showCents = true) {
  if (value == null) return '$0.00';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: showCents ? 2 : 0,
    maximumFractionDigits: showCents ? 2 : 0,
  });
}

export function formatMoneyCompact(value) {
  if (value == null) return '$0';
  const num = Math.abs(typeof value === 'string' ? parseFloat(value) : value);
  const sign = num !== (typeof value === 'string' ? parseFloat(value) : value) ? '-' : '';
  if (num >= 1_000_000) return `${sign}$${(num / 1_000_000).toFixed(1)}M`;
  if (num >= 10_000) return `${sign}$${(num / 1_000).toFixed(0)}K`;
  if (num >= 1_000) return `${sign}$${(num / 1_000).toFixed(1)}K`;
  return `${sign}$${num.toFixed(0)}`;
}

export function formatCents(cents) {
  if (cents == null) return '$0.00';
  return formatMoney(cents / 100);
}

export function formatDate(dateStr) {
  if (!dateStr) return '\u2014';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatDateTime(dateStr) {
  if (!dateStr) return '\u2014';
  return new Date(dateStr).toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function daysSince(dateStr) {
  if (!dateStr) return 0;
  return Math.floor((Date.now() - new Date(dateStr).getTime()) / 864e5);
}

export function formatPercent(value) {
  if (value == null) return '0%';
  return `${value >= 0 ? '+' : ''}${value.toFixed(1)}%`;
}

export function daysUntil(dateStr) {
  if (!dateStr) return 0;
  return Math.ceil((new Date(dateStr).getTime() - Date.now()) / 864e5);
}

export function formatRelative(dateStr) {
  if (!dateStr) return '\u2014';
  const days = daysSince(dateStr);
  if (days === 0) return 'today';
  if (days === 1) return 'yesterday';
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}

export function formatAging(days) {
  if (days == null) return '\u2014';
  if (days === 0) return 'Today';
  if (days === 1) return '1 day';
  return `${days} days`;
}
